import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const bingDesktopTextRaw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'bing_text',
  className: 'bing_text',
  type: 'BingText',
  associationType: 'BingText',
  minimumRequirements: 0,
  localizedText: {
    previewTypeStringKey: _TL_('Bing search ad'),
    stringKey: _TL_(''),
  },
  previewSettings: {
    showLongHeadline: true,
    showDescription: true,
    showUrl: true,
    showMultipleLineLongHeadline: true,
    showUrlMultiline: true,
    showMultipleDescription: true,
    showAdsLabelInlineWithDescription: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    previewContent: {
      border: 'none',
      boxShadow: 'none',
      width: 608,
      height: 110,
      padding: '8px 16px',
    },
    adsLabel: {
      border: '1px solid #ddd',
      padding: '0 2px',
      fontSize: 11,
      fontWeight: 600,
      lineHeight: 1,
      borderRadius: 6,
      margin: '0 4px 0 0',
      display: 'inline',
      color: '#767676',
      opacity: '100%',
      position: 'static',
      maxHeight: 16,
    },
    textContainer: {
      margin: '4px 8px 0px 8px',
    },
    longHeadline: {
      fontWeight: '400',
      fontSize: '20px',
      lineHeight: '24px',
      height: '28px',
      overflow: 'hidden',
    },
    finalUrl: {
      overflow: 'hidden',
      color: '#0b6a0b',
      fontSize: '14px',
      height: '20px',
    },
    description: {
      color: '#333',
      display: 'inline-block',
      fontSize: '13px',
      flexGrow: 1,
    },
    descriptionParent: {
      display: 'flex',
    },
  },
};

export default bingDesktopTextRaw;
